import { useContext } from "react";

import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";

import { C } from "sj-ui-toolkit/src/atlas/utils";

import { VideoContext } from "../../VideoContext";

import S from "./_styles.module.scss";

export default function QuizQuestions() {
  const { quiz, selectedOptions, onMultiAnswerSelect, onQuizSubmit, openFeedbackModal } =
    useContext(VideoContext);

  const allAnswered = quiz?.questionsData?.every(q => selectedOptions[q.id]);

  return (
    <>
      <div className={S.quizBody}>
        <h2 className="atlas-h1">Let's test what you've learned.</h2>
        {quiz?.questionsData?.map((question, idx) => (
          <div className={S.quizQuestion} key={question.id}>
            <fieldset className="flex flex-col gap-2">
              <legend>
                <div className="flex flex-col gap-4 mb-4">
                  <h3 className="atlas-h5 text-muted-aaa">Question {idx + 1}</h3>
                  {question.text}
                </div>
              </legend>
              {question.answers.map((answer, index) => (
                <div key={answer.id} className="flex gap-2">
                  <RadioButton
                    className="mt-0.5"
                    inputId={`radio-${question.id}-${index}`}
                    pt={{ input: { "data-testid": `radio-${question.id}-${index}` } }}
                    name={`question-${question.id}`}
                    value={answer.slug}
                    checked={selectedOptions[question.id] === answer.slug}
                    onChange={() => onMultiAnswerSelect(question.id, answer.slug)}
                  />
                  <label htmlFor={`radio-${question.id}-${index}`}>{answer.text}</label>
                </div>
              ))}
            </fieldset>
            <Button
              label="Provide question feedback"
              aria-label={`Provide feedback for question ${idx + 1}`}
              link
              className="p-0 self-start"
              data-testid={`quiz-question-${question.id}-feedback-button`}
              onClick={() => openFeedbackModal(question.id)}
            />
          </div>
        ))}
      </div>
      <div className={C(S.quizFooter, "flex justify-end")}>
        {!allAnswered && (
          <span id="submit-hint" className="sr-only">
            Please answer all questions before submitting.
          </span>
        )}
        <Button
          label="Submit"
          icon="pi pi-check"
          data-testid="quiz-submit-button"
          onClick={onQuizSubmit}
          disabled={!allAnswered}
          aria-describedby={!allAnswered ? "submit-hint" : undefined}
        />
      </div>
    </>
  );
}
